import React from "react";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import { SwitchProps } from "@material-ui/core/Switch";
import { Trad } from "src/components";

export type TSwitchProps = SwitchProps & {
    Checked: boolean;
    Label: string;
    Name: string;
    OnChange: (name: string, val: unknown) => void;
    Disabled?: boolean;
    OnChangeDerogation?: (e: React.FormEvent<any>) => void;
};

export const _Switch: React.FC<TSwitchProps> = ({ Checked, Disabled, Name, Label, OnChange, OnChangeDerogation, ...rest }) => {
    return (
        <>
            {OnChangeDerogation && <FormControlLabel control={<Checkbox onChange={OnChangeDerogation} name={Name} />} label={Trad.Trad(Label)} />}
            <FormControlLabel
                control={<Switch checked={Checked} onChange={e => OnChange(e.currentTarget.name, e.currentTarget.checked)} name={Name} disabled={Disabled} {...rest} />}
                label={OnChangeDerogation ? "" : Trad.Trad(Label)}
            />
        </>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/form/Switch.tsx